var trackSegmentEvent = {
  openCartDrawer: () => {
    window.analytics.track('Cart Viewed', { from: 'shopify' });
  },
  goToCheckout: () => {
    window.analytics.track('Mpos Purchase Started', { from: 'shopify' });
  },
  addProductToCart: (props) => {
    window.analytics.track('Product Added', props);
  },
  identify: (merchantId) => {
    window.analytics.identify(merchantId);
  }
};